import { createSlice } from '@reduxjs/toolkit'
import { createActions } from "@helper"
import * as actions from '../action'

const walkCategory = (list) => list.map(({ categoryCode, categoryName, categorySort, childList = [] }) => {
    const item = { title: categoryName, value: categoryCode, key: categoryCode, sort: categorySort }
	
    if (childList.length > 0) {
        item.children = walkCategory(childList)
    } else {
        item.isLeaf = true
    }
	
    return item
}).sort((a, b) => a.sort - b.sort)

const initialState = {
    params: {
	    codeType: 'ITEM',
	    codeListStr: '',
	    name: '',
	    brandName: '', // 品牌
	    putawayStatus: '', // 上下架状态
	    categoryStr: [], // 类目
	    displayStatus: '' // 展示状态
    },
    page: {
        pageNum: 1,
        pageSize: 10,
        total: 0
    },
    categories: [],
    goods: []
}

const reducers = createActions({
    getCategoryListAction: {
        success: (state, action) => {
	        const { list = [] } = action.payload
	        
	        const categories = list.map(({ categoryGroupCode }) => ({
		        title: categoryGroupCode,
		        value: categoryGroupCode,
		        key: categoryGroupCode,
		        children: []
	        }))
	        
	        return {
                ...state,
		        params: { ...state.params, categoryStr: [] },
		        categories
	        }
        }
    },
    getInfiniteListAction: {
        success: (state, action) => {
            const { meta: { arg: { categoryGroupCode } }, payload  } = action
	        
            const { categories } = state
            const cs = walkCategory(payload)
	        
            const nCategories = categories.map(item => {
                if (item.value === categoryGroupCode) return { ...item, children: cs }
                return item
            })
			
            return { ...state, categories: nCategories }
        }
    },
    getGoodsListAction: {
        pending: (state, action) => {
            const { arg: { data } } = action.meta
            const { pageNum, pageSize, categoryStr, ...otherParams } = data
	        
            return {
                ...state,
                params: {
                    ...otherParams,
	                categoryStr: categoryStr ? categoryStr.split(',') : []
                },
                page: { ...state.page, pageNum, pageSize }
            }
        },
        success: (state, action) => {
            const { total, list } = action.payload
			
            return {
                ...state,
	            page: { ...state.page, total },
	            goods: list
            }
        }
    }
}, actions)

const goodsSlice = createSlice({
    name: 'goods',
    initialState,
    ...reducers
})

export const getParams = state => state.goods.params

export const getGoods = state => state.goods.goods

export const getPages = state => state.goods.page

export const getCategories = state => state.goods.categories

export default goodsSlice
